import styled from 'styled-components';

type SymbolProps = {
  fontSize: string;
};

export const Symbol = styled.span<SymbolProps>`
  font-size: ${props => props.fontSize};
  line-height: ${props => props.fontSize};
`;
